global.loadFlightsAppDeps = function() {
  // load shared components
  require('../assets/javascripts/booking_app/components/shared/input-counter');

  require('../assets/javascripts/booking_app/controllers/flights/terms-modal-controller');
  require('../assets/javascripts/booking_app/components/flights');
  require('../assets/javascripts/booking_app/services/flights');
  require('../assets/javascripts/booking_app/services/checkout');
}
